type DecoupledEditorConstructor = typeof import('@webthatmatters/orca-ckeditor').default;

type CkEditorModules = {
  CKEditor: typeof import('@ckeditor/ckeditor5-react').CKEditor;
  DecoupledEditor: DecoupledEditorConstructor;
};

let loadPromise: Promise<CkEditorModules> | null = null;

export function loadCkEditorModules(): Promise<CkEditorModules> {
  if (!loadPromise) {
    loadPromise = Promise.all([
      import('@ckeditor/ckeditor5-react'),
      import('@webthatmatters/orca-ckeditor')
    ])
      .then(([reactModule, editorModule]) => ({
        CKEditor: reactModule.CKEditor,
        DecoupledEditor: editorModule.default
      }))
      .catch(error => {
        loadPromise = null;
        throw error;
      });
  }

  return loadPromise;
}
